module.exports = __webpack_public_path__ + "static/bgHeroBusesUrbanos-166677139f06610feaac39528d6c1bdf.jpg";